import { useState } from 'react';
import { api, ago } from '../api';
import { PageHead, Panel, State, Table, useDebounced, useLoad } from '../ui';
import { Person } from './Person';

/** Every registered rider, with their commute and ride. */
export function Riders() {
  const [q, setQ] = useState('');
  const search = useDebounced(q);
  const [open, setOpen] = useState<string | null>(null);
  const { data, error, loading, reload } = useLoad(() => api.riders(search), { deps: [search] });

  if (open) return <Person id={open} mode="admin" onClose={() => setOpen(null)} />;

  return (
    <>
      <PageHead
        title="Riders"
        blurb="Everyone registered to ride, newest first. Open a rider for their routes, rides, trips and support history."
      />
      <Panel
        title={`${data?.length ?? 0} riders`}
        right={
          <>
            <input type="text" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Name, phone, email…" style={{ width: 220 }} />
            <button className="btn sm" onClick={() => void reload()} disabled={loading}>Refresh</button>
          </>
        }
      >
        {error ? <div className="empty">{error}</div> : (
          <Table
            rows={data}
            keyOf={(r) => r.id}
            onRow={(r) => setOpen(r.id)}
            empty={q ? 'Nobody matches that.' : 'No riders registered yet.'}
            columns={[
              { head: 'Rider', cell: (r) => (<><div>{r.full_name ?? <span className="muted">no name yet</span>}</div><div className="mono muted">{r.phone ?? r.email ?? '—'}</div></>) },
              { head: 'Commute', cell: (r) => r.commute ? <small>{r.commute}</small> : <span className="muted">not set up</span> },
              { head: 'Ride', shrink: true, cell: (r) => Number(r.live_rides) ? <State tone="ok">booked</State> : <span className="muted">none</span> },
              { head: 'Rides taken', num: true, shrink: true, cell: (r) => r.rides_taken },
              { head: 'Free left', num: true, shrink: true, cell: (r) => r.trial_rides_remaining },
              { head: 'Joined', shrink: true, cell: (r) => ago(r.created_at) },
            ]}
          />
        )}
      </Panel>
    </>
  );
}
